import * as types from './constants';

const initialState = {
  dataTable: [],
  loading: false,
  message: null,
  count: 0,
  next: null,
  previous: null,
  curr_page: 1,
  errors_api: {},
  queryParsed: false
};

const actions = {
  // Get Regularusers UserGroups
  [types.GET_REGULARUSERS_GROUPS_REQUEST]: state => {
    const data = {
      ...state,
      loading: true
    };

    return { ...data };
  },

  [types.GET_REGULARUSERS_GROUPS_DONE]: (state, { payload }) => {
    const data = {
      ...state,
      ...payload,
      loading: false
    };

    return { ...data };
  },

  [types.GET_REGULARUSERS_GROUPS_FAILED]: (state, { payload }) => {
    const data = {
      ...state,
      loading: false,
      errors_api: payload
    };

    return { ...data };
  },

  // Operations
  [types.REGULARUSERS_GROUPS_SET_PAGE]: (state, { payload }) => {

    const data = {
      ...state,
      curr_page: parseInt(payload) || 1,
      queryParsed: true
    };

    return { ...data };
  }
};

export default (state = initialState, action) => {
  if (actions[action.type]) return actions[action.type](state, action);
  return state;
};